export default __webpack_public_path__ + "static/media/facebook_video_feeds.09698701.jpg";